module.exports = __webpack_public_path__ + "img/32t.93115166.jpg";